
import PageState from "./state"
import mutations from "./mutations"
import { getModule } from '@/store/store'
let u = navigator.userAgent;
let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
let device = isAndroid ? "H5_ANDROID" : "H5_IOS"
let APIS = {
    //ajax地址
    getDataList: `post ${process.env.VUE_APP_API_ROOT}plate/queryDemandList.htm `,
    //分页面获取银行卡列表
    getBankCardList:`/apis/moyin-account/v1/txg/bankCard?device=${device}`,
    //保存银行卡信息
    saveBankCard: {
        custom: true,
        url: '/apis/moyin-account/v1/txg/bankCard',
        method: 'post',
        headers: {
            'content-type': 'application/json',
            'deviceOrigin': device
        }
    },
    //删除银行卡信息
    delBankCard: {
        custom: true,
        url: (data: any) => `/apis/moyin-account/v1/txg/bankCard/${data.id}?device=${device}`,
        method: 'delete'
    }
}
export default {
    ...getModule({
        state: new PageState(),
        mutations,
        actions: {},
        APIS,
        name: "bankCardListPage"
    })
}